export const updateArray = (array,index,updateFn) => {
  return [
  ...array.slice(0,index),
  updateFn(array[index]),
  ...array.slice(index+1)
  ];
}